/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { dependencyEdgeSchema } from './dependencyEdgeSchema';

export const itemDependencyStateSchema = z.object({
  atRiskPredecessorIds: z
    .array(z.int())
    .describe('Predecessor item ids causing this item to be at risk. Deprecated, use edges.'),
  blockedByPredecessorIds: z
    .array(z.int())
    .describe('Predecessor item ids causing this item to be blocked. Deprecated, use edges.'),
  get edges() {
    return z
      .array(dependencyEdgeSchema)
      .describe('Typed dependency edges covering both predecessor and successor directions');
  },
  status: z
    .enum(['NO_ISSUE', 'AT_RISK', 'BLOCKED', 'CANNOT_EVALUATE'])
    .describe('Dependency state derived from predecessor status'),
});
